import type { FriendRecommendation } from '@/api/endpoints/friend-recommendation';
import { Text } from '@/components/ui/text';
import { UserAvatar } from '@/components/ui/user-avatar';
import { View } from 'react-native';

interface RecommendationsCardProps {
  recommendations: FriendRecommendation[];
}

export function RecommendationsCard({ recommendations }: RecommendationsCardProps) {
  if (recommendations.length === 0) return null;

  return (
    <View className="rounded-lg border border-border bg-surface p-3 mb-3" style={{ borderCurve: 'continuous' }}>
      <View className="flex-row items-center">
        <View className="flex-row mr-2">
          {recommendations.slice(0, 3).map((rec, index) => (
            <UserAvatar
              key={rec.id}
              uri={rec.sender_image}
              name={rec.sender_name}
              size={28}
              accessibilityLabel={`${rec.sender_name || 'Friend'}'s photo`}
              className="border-2 border-background"
              style={{
                marginLeft: index > 0 ? -8 : 0,
                zIndex: recommendations.length - index,
              }}
            />
          ))}
        </View>
        <Text className="flex-1 text-sm text-foreground" numberOfLines={2}>
          Recommended by{' '}
          <Text className="font-semibold">
            {recommendations
              .slice(0, 2)
              .map((r) => r.sender_name || 'a friend')
              .join(', ')}
            {recommendations.length > 2 && ` +${recommendations.length - 2} more`}
          </Text>
        </Text>
      </View>
    </View>
  );
}
